import React, { useState } from "react";
import ProfileImg from "images/profile-green.png";
import MessageIcon from "images/message-green.png";
import Alert from "components/alert";

const gradinetStyle = {
  indigo: " from-indigo-900",
  green: " from-green-700",
  none: "",
};

const backgroundColor = {
  indigo: " bg-indigo-900",
  green: " bg-green-700",
  none: "",
};

const inputs = [
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    icon: ProfileImg,
  },
  {
    name: "email",
    type: "email",
    placeholder: "Enter your email address",
    icon: MessageIcon,
  },
];

const Contact = ({ data: { image, title, description, overlayColor, prefillMessage } }) => {
  const [submitting, setSubmitting] = useState(false);
  const [info, setInfo] = useState({
    from: "",
    name: "",
    email: "",
    message: prefillMessage || "",
  });
  const [messageStatus, setMessageStatus] = useState({
    message: "",
    type: "success", // "success" or "error"
  });

  const onSubmit = async (e) => {
    e.preventDefault();

    const { name, email, message, from } = info;

    const apiUrl = "https://phld5phrx8.execute-api.eu-north-1.amazonaws.com/default/sendEmail";

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'xba0Ld6dOb6gpymoiDiSJa0DnNHyolQM5gUQhEzh'
        },
        body: JSON.stringify({
          to: "support@oldgoldracing.com",
          from: "support@oldgoldracing.com",
          replyTo: email,
          subject: `Contact us email by ${name}, ${email}`,
          // text: `From: ${name} <${email}>`,
          html: `<div>
          <p>${message}</p>
          <p>
            -- <br />
            This e-mail was sent from a contact form on
            <a href="https://oldgoldracing.com"> Old Gold Racing</a>
          </p>
        </div>`,
        })
      });

      const responseData = await response.json();

      if (responseData.statusCode === 200) {
        setMessageStatus({
          message: "Email sent!",
          type: "success",
        });
      } else {
        throw new Error("Failed to send email");
      }

      setSubmitting(false);
    } catch (error) {
      setMessageStatus({
        message: "Something went wrong.",
        type: "error",
      });

      console.error("There was an error sending the email:", error);
      setSubmitting(false);
    }
  };

  return (
    <div className="relative">
      <div className={`relative ${backgroundColor[overlayColor]}`}>
        {image && (
          <div className="w-full h-full absolute top-0 left-0 flex justify-end sm:relative">
            <div className="relative w-1/2 flex sm:w-full sm:max-h-96">
              {overlayColor && (
                <div
                  className={`w-full h-full absolute top-0 left-0 z-[2] bg-gradient-to-r from-10% sm:bg-gradient-to-t ${gradinetStyle[overlayColor]}`}
                />
              )}
              <img
                src={image?.src}
                alt={image?.alt}
                className="w-full object-cover"
              />
            </div>
          </div>
        )}

        <div className="container relative w-full pt-36 pb-36 z-[2] sm:pt-0 sm:pb-24">
          <div className="w-3/5 sm:w-full md:w-full">
            <div className="header !text-yellow-400 mb-2.5 sm:text-h1">
              {title}
            </div>
            <div className="font-sans text-sm text-gray-300">{description}</div>
            <div className="mt-10 max-w-md sm:max-w-full">
              <form className="flex flex-col gap-8" onSubmit={onSubmit}>
                {inputs?.map(({ name, placeholder, icon, type }, index) => (
                  <div className="relative w-full" key={index}>
                    <input
                      type={type}
                      value={info[name]}
                      onChange={({ target: { value } }) =>
                        setInfo({ ...info, [name]: value })
                      }
                      className="w-full border border-solid border-gray-700 py-4 pl-11 pr-3 bg-transparent outline-none text-gray-400 rounded-md"
                      placeholder={placeholder}
                      required
                    />
                    <img
                      src={icon}
                      className="!absolute left-3 bottom-1/2 translate-y-1/2 w-6 h-6"
                    />
                  </div>
                ))}
                <textarea
                  placeholder="Message"
                  className="w-full border border-solid border-gray-700 py-4 px-6 bg-transparent outline-none text-gray-400 rounded-md h-52 resize-none"
                  value={info["message"]}
                  onChange={({ target: { value } }) =>
                    setInfo({ ...info, message: value })
                  }
                />
                <button type="submit" className="btn btn-primary">
                  {submitting ? "Sending Message..." : "Send Message"}
                </button>
              </form>
              {messageStatus.message && (
                <Alert
                  success={messageStatus.type === "success"}
                  message={messageStatus.message}
                  onClose={() => setMessageStatus({ message: "", type: "success" })}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
